import { Shield, Award, Users, Building2, Factory, HardHat, Flame, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const trustIcons = [Shield, Award, CheckCircle2, Users, Shield, CheckCircle2, Award, Shield, Building2, Factory, HardHat, Flame, Shield, Award, CheckCircle2, Users, Building2, Factory, HardHat, Award];

export function TrustMarquee() {
  const { t } = useTranslation('home');
  
  const trustItems = (t('trustMarquee.items', { returnObjects: true }) as string[]).map((text, index) => ({
    icon: trustIcons[index % trustIcons.length],
    text,
  }));

  // Duplicate items once - the animation will loop seamlessly at 50%
  const duplicatedItems = [...trustItems, ...trustItems];
  
  return (
    <section className="py-8 bg-gradient-to-r from-primary via-primary/95 to-primary overflow-hidden relative">
      {/* Gradient Edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-primary to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-primary to-transparent z-10" />
      
      {/* Single container with duplicated content - moves 50% then resets seamlessly */}
      <div className="flex animate-marquee-rtl">
        {duplicatedItems.map((item, index) => (
          <div 
            key={index}
            className="flex items-center gap-3 px-6 py-2 mx-2 rounded-full bg-primary-foreground/5 border border-primary-foreground/10 backdrop-blur-sm whitespace-nowrap flex-shrink-0"
          >
            <item.icon className="w-5 h-5 text-accent" />
            <span className="text-primary-foreground/90 font-medium text-sm">{item.text}</span>
          </div>
        ))}
      </div>
      
      <style>{`
        @keyframes marquee-rtl {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-marquee-rtl {
          animation: marquee-rtl 45s linear infinite;
        }
      `}</style>
    </section>
  );
}
